/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { PictureType } from "../types/EmediaTypes";

type Response = {
  payload: PictureType[];
};

export function useProjectFileList(project_id:string) {
  const api = useApi();
  const [dataFile, setData] = useState<PictureType[]>([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api
      .get(`/project/get-project-file?project_id=${project_id}`)
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? [];
        setData(data);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  const refetchList = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, []);

  return {
    dataFile,
    isLoading,
    refetchList,
  };
}
